import React, { useState, useEffect } from 'react'
import Loader from '../../../Components/Base_url/Loader';
import Service_card from './Service_card'
import Tab from './Tab';
function Services_ui({ Service, serviceloading, slug }) {
    console.log("Service", Service)

    const [activeTab, setActiveTab] = useState('');

    useEffect(() => {
        if (Service.length > 0 && !activeTab) {
            setActiveTab(Service[0].name);
        }
    }, [Service, activeTab]);

    const filteredService = Service.filter(s => s.name === activeTab);
    console.log("filteredService", filteredService);

    return (
        <>
            <div class="tabs-container">
                <div className="tabs container">
                    {Service.map((servi, index) => (
                        <Tab
                            key={index}
                            servi={servi}
                            isActive={activeTab === servi.name}
                            onClick={() => setActiveTab(servi.name)}
                        />
                    ))}

                </div>
                {filteredService.map((servi, index) => (
                    <Service_card key={index} servi={servi} />
                ))}


            </div>


        </>
    )
}

export default Services_ui